import io from 'socket.io-client';
import { getSocketUrl } from '../config/config';

let currentUrl = getSocketUrl();
console.log('[Socket.IO] Initializing socket target:', currentUrl);

const socket = io(currentUrl, {
  autoConnect: false,
  transports: ['websocket', 'polling'],
  rejectUnauthorized: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 10000,
});

socket.on('connect', () => {
  console.log(`%c[Socket.IO] Connected successfully! ID: ${socket.id} (URL: ${socket.io.uri})`, 'color: green; font-weight: bold;');
});

socket.on('connect_error', (err) => {
  console.warn(`%c[Socket.IO] Connection error to ${socket.io.uri}: ${err.message}`, 'color: orange; font-weight: bold;');
});

socket.on('disconnect', (reason) => {
  console.log(`%c[Socket.IO] Disconnected from ${socket.io.uri}: ${reason}`, 'color: red;');
});

export const initSocket = () => {
  const latestUrl = getSocketUrl();
  if (socket.io.uri !== latestUrl) {
    console.log(`[Socket.IO] Target URL changed from ${socket.io.uri} to ${latestUrl}. Switching...`);
    socket.disconnect();
    socket.io.uri = latestUrl;
  }
  if (!socket.connected) {
    console.log('[Socket.IO] Connecting socket to:', socket.io.uri);
    socket.connect();
  }
};

export const reconnectSocket = (targetUrl) => {
  const url = targetUrl || getSocketUrl();
  console.log(`[Socket.IO] Explicit reconnect to ${url}`);
  socket.disconnect();
  socket.io.uri = url;
  socket.connect();
};

export const disconnectSocket = () => {
  if (socket && socket.connected) {
    console.log('[Socket.IO] Disconnecting socket...');
    socket.disconnect();
  }
};

export const isSocketConnected = () => !!(socket && socket.connected);

export default socket;
